export default "__VITE_ASSET__7dad9c1a__"